import React, { createContext, useState, useEffect, useCallback } from 'react';
import { translateTexts, getCachedTranslations } from '../utils/translate';
import ALL_TRANSLATION_KEYS from './allTranslationKeys';

export const TranslationContext = createContext();

export function TranslationProvider({ children }) {
  const LANG_KEY = 'selected_language_v1';
  const [language, setLanguage] = useState(() => localStorage.getItem(LANG_KEY) || 'en');
  // Initialize translations from cache for the selected language
  const [translations, setTranslations] = useState(() => getCachedTranslations(localStorage.getItem(LANG_KEY) || 'en'));

  useEffect(() => {
    localStorage.setItem(LANG_KEY, language);
  }, [language]);

  // On language change, load translations from cache immediately
  useEffect(() => {
    setTranslations(getCachedTranslations(language));
  }, [language]);

  // Fetch translations for a set of texts (helper)
  const fetchTranslations = useCallback((visibleTexts = []) => {
    if (language === 'en' || visibleTexts.length === 0) {
      setTranslations({});
      return;
    }
    let cancelled = false;
    translateTexts(visibleTexts, language).then(res => {
      if (!cancelled) setTranslations(prev => ({ ...prev, ...res })); // Merge with any existing
    });
    return () => { cancelled = true; };
  }, [language]);

  // Automatically fetch all translations for the selected language
  useEffect(() => {
    if (language !== 'en') {
      fetchTranslations(ALL_TRANSLATION_KEYS);
    }
  }, [language, fetchTranslations]);

  const t = useCallback(
    (text) => (language === 'en' ? text : translations[text] || text),
    [language, translations]
  );

  return (
    <TranslationContext.Provider value={{ t, setLanguage, language, fetchTranslations }}>
      {children}
    </TranslationContext.Provider>
  );
} 